export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f4bcbf038afbcb5354ab9c0fe32be5af2369ec2ec&name=fetchTypeahead!'